import { SUPER_GROUP_ID } from 'config';
export function deriveUserRole(group, isAdmin) {
    const candidate = `${group.name} ${group.type}`.toLowerCase();
    if (isAdmin ||
        group.id === SUPER_GROUP_ID ||
        candidate.includes('owner') ||
        candidate.includes('admin') ||
        candidate.includes('super')) {
        return 'owner';
    }
    return 'agent';
}
